import { Grid } from '@methanesat/ui-components';
import { ErrorBoundary } from 'react-error-boundary';
import { TargetDrawerProps } from '../../../../../types';
import { TargetCard } from './TargetCard';
import { useTranslate } from '../../../../../hooks';
import { DrawerWithCards } from '../../DrawerWithCards/DrawerWithCards';

export const TargetDrawerWithCards = ({
    cardData,
    activeCardIndex,
    handleInfoOnDateChange,
    page,
    ...otherProps
}: TargetDrawerProps) => {
    const t = useTranslate();
    return (
        <DrawerWithCards
            activeCardIndex={activeCardIndex}
            {...otherProps}
            title={
                cardData.length === 1
                    ? t('emissionsMapPage.drawerWithCards.emissions.titleSingular', {
                          count: cardData.length
                      })
                    : t('emissionsMapPage.drawerWithCards.emissions.titlePlural', {
                          count: cardData.length
                      })
            }
            shareable
        >
            <Grid container rowSpacing={3}>
                {cardData.map((info, idx) => {
                    return (
                        <Grid size={{ xs: 12 }} key={idx}>
                            <ErrorBoundary fallback={<div>{t('emissionsMapPage.error.targetEmissionData')}</div>}>
                                <TargetCard
                                    info={info}
                                    active={idx === activeCardIndex}
                                    handleInfoOnDateChange={handleInfoOnDateChange}
                                    page={page}
                                />
                            </ErrorBoundary>
                        </Grid>
                    );
                })}
            </Grid>
        </DrawerWithCards>
    );
};
